<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 54 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path xmlns="http://www.w3.org/2000/svg" d="M18.8483 40.6652L0.336863 22.0068C0.230104 21.8993 0.145384 21.7714 0.0875723 21.6305C0.0297611 21.4896 0 21.3386 0 21.186C0 21.0334 0.0297611 20.8824 0.0875723 20.7415C0.145384 20.6006 0.230104 20.4727 0.336863 20.3652L5.01016 15.6243C5.45672 15.1718 6.17849 15.1718 6.62505 15.6243L18.812 27.9001C19.2585 28.3526 19.9855 28.3473 20.4321 27.8948L47.3607 0.343994C47.8072 -0.113784 48.5342 -0.113784 48.9859 0.338732L53.6644 5.07962C54.111 5.53213 54.111 6.26353 53.6696 6.71604L24.3317 36.7136L24.3369 36.7189L20.4684 40.66C20.0218 41.1125 19.2949 41.1125 18.8483 40.6652Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: '#006EFF' },
  },
  name: "IconChoiseChat",
};
</script>
